// src/services/api.js
import axios from 'axios';
import { auth } from '../components/Firebase';

const configuredApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const normalizedApiUrl = configuredApiUrl.replace(/\/$/, '');
const apiBaseUrl = normalizedApiUrl.endsWith('/api') ? normalizedApiUrl : `${normalizedApiUrl}/api`;

const api = axios.create({
  baseURL: apiBaseUrl,
});

api.interceptors.request.use(async (config) => {
  const token = await auth.currentUser?.getIdToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchLeagueData = (leagueId) =>
  api.get(`/league/${leagueId}`).then((res) => res.data);

export const fetchTeams = (params = {}) =>
  api.get('/teams', { params }).then((res) => res.data);

export const createSimulation = (payload) =>
  api.post('/simulation/create', payload).then((res) => res.data);

const authConfig = async () => {
  const token = await auth.currentUser?.getIdToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const fetchConditionScenarios = async (competitionId) =>
  api.get('/condition-scenarios', {
    params: { competitionId },
    ...(await authConfig()),
  }).then((res) => res.data);

export const createConditionScenario = async (payload) =>
  api.post('/condition-scenarios', payload, await authConfig()).then((res) => res.data);

export const updateConditionScenario = async (scenarioId, payload) =>
  api.put(`/condition-scenarios/${scenarioId}`, payload, await authConfig()).then((res) => res.data);

export const deleteConditionScenario = async (scenarioId) =>
  api.delete(`/condition-scenarios/${scenarioId}`, await authConfig()).then((res) => res.data);

export const analyzeConditionScenario = async (payload) =>
  api.post('/condition-scenarios/analyze', payload, await authConfig()).then((res) => res.data);

export default api;
